import React, { useState } from "react";
import { Helmet } from "react-helmet";
import CoursesData from "../content.json";
import { BsLightningFill } from "react-icons/bs";
import Courses from "../Components/Courses";

function ITEP() {
  const [ITEPData] = useState(CoursesData.Courses[2]);
  return (
    <>
      <Helmet>
        <title>ITEP (Foundation) | University of Education</title>
      </Helmet>
      <div className="PageContainer">
        <div className="">
          <div id="Heading" className="CourseTitle" data-aos="fade-up">
            <h1>{ITEPData.course_fullname}</h1>
          </div>
          <br />
          <p className="CourseDesc" data-aos="fade-up">
            {ITEPData.course_desc}
          </p>
          <br />

          <div className="UnitsGrid" data-aos="fade-up" style={{ marginBottom: "40px" }}>
            <h3 style={{ borderBottom: "2px solid #eee", paddingBottom: "10px", marginBottom: "20px", color: "#333" }}>Approved Units</h3>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "15px" }}>
              {[
                "01 Unit B.A. B.Ed.",
                "01 Unit B.Sc. B.Ed.",
                "01 Unit B.Com. B.Ed."
              ].map((unit, index) => (
                <div key={index} style={{ 
                  display: "flex", 
                  gap: "12px", 
                  alignItems: "center", 
                  padding: "15px 20px",
                  backgroundColor: "#ffffff",
                  borderRadius: "10px",
                  border: "1px solid #e0e0e0",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                  transition: "transform 0.2s ease"
                }}>
                  <div style={{ backgroundColor: "#fff8e1", padding: "8px", borderRadius: "50%", display: "flex" }}>
                    <BsLightningFill style={{ color: "#ffa000" }} />
                  </div>
                  <span style={{ fontWeight: "600", color: "#444" }}>{unit}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="CourseDetailsContainer" data-aos="fade-up">
            <div id="Secondary_Heading">
              <h3>Course Detail</h3>
            </div>
            <div className="CourseTable">
              <table>
                <tbody>
                  <tr>
                    <td>Course -</td>
                    <td>{ITEPData.course_fullname}</td>
                  </tr>
                  <tr>
                    <td>Recognizing Body -</td>
                    <td>{ITEPData.course_certification}</td>
                  </tr>
                  <tr>
                    <td>Duration -</td>
                    <td>{ITEPData.course_duration}</td>
                  </tr>
                  <tr>
                    <td>No. of Semester -</td>
                    <td>{ITEPData.course_sem}</td>
                  </tr>
                  <tr>
                    <td>Seats -</td>
                    <td>{ITEPData.course_seat}</td>
                  </tr>
                  <tr>
                    <td>Eligibility -</td>
                    <td>{ITEPData.course_eligibility}</td>
                  </tr>
                  <tr>
                    <td>Admission Procedure -</td>
                    <td>Through National Testing Agency (NTA) through the National Common Entrance Test (NCET)</td>
                  </tr>
                  <tr>
                    <td>Fees -</td>
                    <td>{ITEPData.course_fee}</td>
                  </tr>
                  <tr>
                    <td>Affiliation -</td>
                    <td>{ITEPData.university}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <section>
            <Courses />
          </section>
        </div>
      </div>
    </>
  );
}

export default ITEP;
